/**
 * ProgressTracker, 5-step dot variant (design "06 · Meetings" → Meeting v2 — Legislation tab vpHXI, row stepper oVprL):
 * Filed → Introduced → Committee → Council → Final. Done steps are 8px ink dots on a 2px ink line, the current step a
 * 12px ring with a 3px ink stroke and an ink label, the rest 8px hollow rings on a 1px line with muted labels.
 * 288 × 38; steps 58px apart, labels 56px wide centered under each dot.
 *
 * On mount the done line fills from Filed to the current step and each dot appears as the line reaches it
 * (motion.ts recipes.stageFill). Reduced motion (the OS or Settings → Reduce motion): no fill, a plain fade at most.
 */
import { useState } from "react";
import type { CSSProperties } from "react";
import type { Legislation } from "../../types";
import { STAGE_LABELS } from "../../legislation/stages";
import { prefersReducedMotion } from "../../motion";

const X = (i: number) => 28 + i * 58; // step centers

export function ProgressTracker({ stage }: { stage: Legislation["stage"] }) {
  const [animate] = useState(() => !prefersReducedMotion());
  return (
    <div className="tracker" role="img" aria-label={`Stage: ${STAGE_LABELS[stage]} (${stage + 1} of 5)`} data-animate={animate && stage > 0 ? "" : undefined}>
      <span className="tracker-base" />
      <span className="tracker-done" style={{ width: X(stage) - X(0) }} />
      {STAGE_LABELS.map((label, i) => {
        const state = i < stage ? "done" : i === stage ? "current" : "todo";
        return (
          <span key={label}>
            <span className="tracker-dot" data-state={state} style={{ left: X(i), "--at": stage > 0 ? Math.min(i / stage, 1) : 0 } as CSSProperties} />
            <span className="tracker-label" data-current={i === stage || undefined} style={{ left: X(i) - 28 }}>{label}</span>
          </span>
        );
      })}
    </div>
  );
}
